export const useAddressHelpers = () => {
  const copyAddressObject = (targetAddress, sourceAddress) => {
    targetAddress.line1 = sourceAddress.line1;
    targetAddress.line2 = sourceAddress.line2;
    targetAddress["unit-number"] = sourceAddress["unit-number"];
    targetAddress.province = sourceAddress.province;
    targetAddress.city = sourceAddress.city;
    targetAddress["postal-code"] = sourceAddress["postal-code"];
    targetAddress["street-direction"] = sourceAddress["street-direction"];
    targetAddress["street-name"] = sourceAddress["street-name"];
    targetAddress["street-number"] = sourceAddress["street-number"];
    targetAddress["street-type"] = sourceAddress["street-type"];
  };
  return {
    copyAddressObject
  };
};